export default __webpack_public_path__ + "static/media/2411153.413f8291.webp";